// src/components/Loading.js
import React from "react";

import "../../assets/css/loading.css";

const Loading = () => {
  // src/data/pianoFacts.js
const pianoFacts = [
  "O piano possui mais de 12.000 peças individuais em seu mecanismo.",
  "O piano mais caro do mundo custou US$ 3,22 milhões - um Steinway pintado por artistas pop.",
  "O maior piano do mundo tem 5,7 metros de comprimento e pesa 1,4 toneladas.",
  "Beethoven continuou compondo mesmo depois de ficar surdo, sentindo as vibrações do piano.",
  "O piano foi inventado por Bartolomeo Cristofori na Itália por volta de 1700.",
  "Um piano de cauda de concerto tem cerca de 230 cordas, cada uma com tensão de 70 a 100 kg.",
  "O termo 'piano' vem de 'pianoforte', que significa 'suave-forte' em italiano.",
  "O piano pode tocar mais notas simultaneamente do que qualquer outro instrumento.",
  "O piano mais antigo que ainda existe foi construído em 1720 e está no Metropolitan Museum em NY.",
  "Liberace tinha um piano coberto de espelhos que pesava 500 kg a mais que um piano normal.",
  "O piano é considerado um instrumento de percussão e cordas ao mesmo tempo.",
  "Em 1965, David Bowie compôs 'Space Oddity' em um piano que tinha teclas pintadas de preto e brancas invertidas.",
  "O piano vertical foi inventado para ocupar menos espaço em casas menores.",
  "O sustenido (#) e o bemol (♭) são a mesma tecla no piano, chamada de 'enarmônica'.",
  "O maior concerto para piano já realizado teve 100 pianos e 200 pianistas tocando juntos."
];
  // Seleciona uma curiosidade aleatória
  const randomFact = pianoFacts[Math.floor(Math.random() * pianoFacts.length)];

  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <img 
          src="/img/logo_waldir_footer.webp" 
          alt="Waldir Pianos Logo" 
          className="loading-logo" 
        />
        <p className="loading-text">{randomFact}</p>
        <div className="loading-spinner"></div>
      </div>
    </div>
  );
};

export default Loading;